<template>
  <div id="equipes-saude">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Equipes"
            description=""
            url="/administracao"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2451"
            pageIdentifier="equipes-saude"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <tabela-cadastros
            :cadastros="cadastros"
            :loading="loading"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import TabelaCadastros from './TabelaCadastros.vue'
import SectionTitle from '@/components/SectionTitle'

export default {
  metaInfo: {
    title: 'Equipes',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    TabelaCadastros,
    SectionTitle,
  },
  computed: {},
  data() {
    return {
      cadastros: [],
      loading: false,
    }
  },
  mounted() {
    this.buscarEquipesSaude()
  },
  methods: {
    /**
     * Busca as equipes de saúde vinculadas ao município.
     */
    async buscarEquipesSaude() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/municipio/' + this.$store.state.cod_ibge + '/equipes-saude'
        )
        if (response) {
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style></style>
